<template>
  <a-select
          :value="localValue"
          :disabled="disabled"
          placeholder="请选择"
          style="width: 100%"
          :default-active-first-option="false"
          :show-arrow="true"
          @change="handleChange"
  >
    <a-select-option v-for="d in options" :key="d.value">
      {{ d.text }}
    </a-select-option>
  </a-select>
</template>
<script>
    import {searchStdProduceDic as getDic} from '../../../api/api';
    import mixin from '../mixin/AExtStringMixin'

    export default {
        mixins:[mixin],
        props: {
            disabled: {
                type: Boolean,
                default: false
            },
        },
        data() {
            return {
                options: [],
                localValue: undefined,
            };
        },
        created(){
            this.init();
        },
        methods: {
            init(){
                if(this.localValue)
                {
                    this.options=[{value:this.localValue,text: ''}];
                }
                this.handleSearch('');
            },
            handleSearch(value) {
                getDic(value).then(result => {

                    if (result.data && result.data.succ) {
                        const data = [];
                        let hasTag=false;
                        if(this.localValue) {
                            result.data.data.forEach(r => {
                                if (r.id === this.localValue) {
                                    hasTag = true;
                                }
                            });
                        }
                        result.data.data.forEach(r => {
                            data.push({
                                value: r.id,
                                text: r.name,
                            });
                        });
                        this.options = data;
                        if(!hasTag&&this.localValue)
                        {
                            this.options.push({value:this.localValue,text: ''});
                        }
                    }
                }).catch(() => {
                    this.options = []
                })
            },
            handleChange(value,option) {
                this.localValue = value;
                console.log(option)
            },
        },
    };
</script>
